import { GraphQL } from "@rpi/openapi-api";
import { SearchInput } from "../../../configuration/filters/searchInput";
import { SearchGeneral } from "../../../utils/graphql.util";

export function getPaymentsEmptyMessage(args: { isSandbox: boolean; hasActiveSearch: boolean }): string {
  if (args.isSandbox) return "There are no payments for test orders in the sandbox.";
  if (args.hasActiveSearch) return "No payments found.";
  return "Your payments will appear here.";
}

export function hasActivePaymentsSearch(
  searchInputs: SearchInput<GraphQL.PaymentSearchFields>[],
  searchGeneral: SearchGeneral<GraphQL.PaymentsQueryVariables>
): boolean {
  return searchInputs.length > 0 || Boolean(searchGeneral);
}
